import 'es6-promise/auto'
import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'

// 解决hover效果的问题
document.body.addEventListener('touchstart', function(){ })

Vue.config.productionTip = false

Vue.prototype.$http = axios
Vue.prototype.isX = /iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375)
// Vue.use(KsVueFullpage)
new Vue({
  render: h => h(App),
}).$mount('#app')

//微信和云音乐分享
const shareInfo = {
  img: "https://3.163.com/zhongchou_share_icon2.jpg",
  url: "https://3.163.com/jd/?sourcefrom=weixin_share",
  music_url: "https://3.163.com/jd/?sourcefrom=music_share",
  desc: "为音乐而生 因热爱相聚",
  title: "丁磊邀你共创网易新一代音乐产品",
  timeline_title: "丁磊邀你共创网易新一代音乐产品",
  callback: function(shareType) {
    window.gtag('event', 'weixinshare_callback', {
      'event_category' : 'share',
      'event_label' : shareType
    });
  }
}

window.CloudMusic.setShareData({
  name: shareInfo.title,  // ?
  title: shareInfo.title,
  subTitle: shareInfo.desc,
  text: shareInfo.timeline_title,  // 微博的标题
  picUrl: shareInfo.img,  // 缩略图
  link: shareInfo.music_url     // 页面链接
})

window.CloudMusic.onShare(function(isSuccess, shareType) {
  if(isSuccess){
    window.gtag('event', 'musicshare_callback', {
      'event_category' : 'share',
      'event_label' : shareType
    });
  }
})

window.shareConfig = shareInfo

window._PSC_C_API = (function(){
	if (document.addEventListener) {
		document.addEventListener("WeixinJSBridgeReady", WXReadyFn, false);
	} else if (document.attachEvent) {
		document.attachEvent("WeixinJSBridgeReady", WXReadyFn);
		document.attachEvent("onWeixinJSBridgeReady", WXReadyFn);
	}

	function isFunction(obj) {
		return typeof obj == 'function';
	}

	function WXReadyFn() {
		try {
			window.WeixinJSBridge.on("menu:share:timeline", function() {
				window.WeixinJSBridge.invoke("shareTimeline", {
					"img_url": window.shareConfig.img,
					"img_width": 100,
					"img_height": 100,
					"link": window.shareConfig.url,
					"desc": window.shareConfig.desc,
					"title": window.shareConfig.timeline_title?window.shareConfig.timeline_title:window.shareConfig.title
				}, function() {
					try {
						isFunction(window.shareConfig.callback) && window.shareConfig.callback("timeline");
					} catch (e) {//
					}
				},function(){});
			});
			window.WeixinJSBridge.on("menu:share:appmessage", function() {
				window.WeixinJSBridge.invoke("sendAppMessage", {
					"img_url": window.shareConfig.img,
					"img_width": 100,
					"img_height": 100,
					"link": isFunction(window.shareConfig.url) ? window.shareConfig.url(3) : window.shareConfig.url,
					"desc": window.shareConfig.desc,
					"title": window.shareConfig.title
				}, function() {
					try {
						isFunction(window.shareConfig.callback) && window.shareConfig.callback("appmessage");
					} catch (e) {//
					}
				});
			});
			isFunction(window.shareConfig.readycallback) && window.shareConfig.readycallback();
		} catch (e) {//
    }
	}
})();
